import React, { useState, useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import GlobalStyle from 'theme/GlobalStyles';

import Helmet from './Helmet';
import InitApp from './InitApp';
import Header from './Header';
import Main from './Main';
import Footer from './Footer';
import SubscribeMessage from './SubscribeMessage';
import CookieWarn from './CookieWarn';
import AiSearch from './AiSearch';

const Layout = () => {
  const { pathname } = useLocation();
  const [isAiOpened, setAiOpened] = useState(false);
  const onOpenAi = useCallback(() => setAiOpened(true), []);
  const onCloseAi = useCallback(() => setAiOpened(false), []);

  if (/^\/business|^\/b2b/.test(pathname))
    return (
      <>
        <Helmet />
        <GlobalStyle />
        <Outlet />
      </>
    );

  return (
    <>
      <Helmet />
      <GlobalStyle />
      <Header onOpenAi={onOpenAi} />
      <SubscribeMessage />
      <InitApp>
        <Main>
          <Outlet />
        </Main>
        <Footer />
        <CookieWarn />
      </InitApp>
      <AiSearch isOpened={isAiOpened} onClose={onCloseAi} />
    </>
  );
};

export default Layout;
